import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToPageTop } from "../scrollToPageTop";

/** Scroll to top on React Router path / search changes (login, invoice, etc.). */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useLayoutEffect(() => {
    scrollToPageTop();
  }, [pathname, search]);

  return null;
}
